import { ProgramTemplateSessionTranslation } from "../../models/programs/program-template-session.model"
import { ProgramTemplateSessionTranslationDto } from "../../dto/programs/program-template-sessions-translations.dto";

export class ProgramTemplateSessionTranslationMapper {
  public static toModel(dto: ProgramTemplateSessionTranslationDto): ProgramTemplateSessionTranslation {
    return {
      languageId: dto.language_id,
      title: dto.title,
      description: dto.description
    }
  }

  public static toDto(dto: ProgramTemplateSessionTranslation): ProgramTemplateSessionTranslationDto {
    return {
      language_id: dto.languageId,
      title: dto.title,
      description: dto.description
    }
  }
}